import React, { useState, useEffect } from "react";
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from 'react-paginate';
import Dropdown from 'react-bulma-dropdown';
import { IoCashOutline, IoCashSharp, IoCloseCircleOutline, IoListOutline } from "react-icons/io5";

function ContractList() {
  const [contracts, setContract] = useState([]);
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [msg, setMsg] = useState("");
  const [keywordcontract, setKeywordContract] = useState("");
  const [querycontract, setQueryContract] = useState("");
  const [keywordcust, setKeywordCust] = useState("");
  const [querycust, setQueryCust] = useState("");
  const [selectcustomer, setSelectCustomer] = useState(null);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '29px', // Adjust the minimum height of the control
      fontSize: '14px', // Adjust the font size
    }),
    valueContainer: (base) => ({
      ...base,
      height: '29px', // Set the specific height for the value container
      padding: '0 8px', // Adjust padding as needed
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: '0 4px', // Adjust padding for the clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '0 4px', // Adjust padding for the dropdown indicator
    }),
    menuList: (base) => ({
      ...base,
      fontSize: '14px', // Adjust the font size of the dropdown menu
    }),
  };

  const SmallSelect = (props) => (
    <Select styles={customStyles} {...props} />
  );

  useEffect(() => {
    const fetchOptions = async () => {
      setIsLoading(true);
      try {
        // Replace with your actual Node.js API endpoint
        const result = await axios.get(`${API_BASE_URL}/client`, {
          headers: {
              'X-API-Key': API_KEY
          },
        }); 
        const data = result.data;

        // Map the API data to the format react-select expects: { value: '', label: '' }
        const formattedOptions = data.map(item => ({
          value: item.id,
          label: item.name,
        }));

        setOptions(formattedOptions);
        setError(null);
      } catch (err) {
        setError('Failed to load options');
       // console.error(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchOptions();
    getContracts();
  }, [page, keywordcust, keywordcontract]);

  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setQueryCust("");
      setSelectCustomer(null);
      setKeywordCust("");
      //console.error("Event or event target is null/undefined");
      return; // Exit the function gracefully
    }
    const newValue = selectedOption;
    setQueryCust(newValue.value);
    setSelectCustomer(newValue);
    //console.log('Option selected:', newValue);
  };

  const getContracts = async () => {
    const response = await axios.get(
      `${API_BASE_URL}/contracts?search_contract=${keywordcontract}&search_customer=${keywordcust}&page=${page}&limit=${limit}`, 
      {
        headers: {
            'X-API-Key': API_KEY
        },
      }
    );
    
    setContract(response.data.result);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const changePage = ({ selected }) => {
    setPage(selected);
    if (selected === 9) {
      setMsg(
        "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
      );
    } else {
      setMsg("");
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeywordCust(querycust);
    setKeywordContract(querycontract);
  };

  const deleteContract = async (contractId) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      await axios.delete(`${API_BASE_URL}/contracts/${contractId}`);
      getContracts();
    } else {
      return
    }      
  };

  const calculateGuarantee = (endDate) => {
    const start = new Date();
    const end = new Date(endDate);
    const timeDifference = end.getTime() - start.getTime(); // Difference in milliseconds
    const millisecondsPerDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
    const daysDifference = Math.floor(timeDifference / millisecondsPerDay); // Use Math.floor for whole days
    if(daysDifference < 0){
      return <span className="tag is-danger">Expired</span>;
    }else{
      return <span className="tag is-success">Guarantee</span>;
    }
  };

  const calculateContract = (endDate) => {
    const start = new Date();
    const end = new Date(endDate);
    const timeDifference = end.getTime() - start.getTime(); // Difference in milliseconds
    const millisecondsPerDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
    const daysDifference = Math.floor(timeDifference / millisecondsPerDay); // Use Math.floor for whole days
   // return daysDifference;
    if(daysDifference < 30){
      return <span className="tag is-rounded is-danger">{daysDifference} Days</span>;
    }else{
      return <span className="tag is-rounded is-success">{daysDifference} Days</span>;
    }
    
  };

  return (
    <div className="container">
        <h1 className="title is-size-5">Data Contract</h1>        
        <Link to="/contracts/add" className="button is-small is-primary mb-2">
          Add New Contract
        </Link>        
        <div className="columns">
          <div className="column is-9">
            <form onSubmit={searchData}>
              {error && <p style={{ color: 'red' }}>{error}</p>}
              <div className="columns">
                <div className="column is-5">                
                  <div className="control">
                    <div className="is-fullwidth mr-2">
                      <input
                          type="text"
                          className="input is-small"
                          value={querycontract}
                          onChange={(e) => setQueryContract(e.target.value)}
                          placeholder="Search by No Contract..." />
                    </div>
                  </div>
                </div>
                <div className="column is-6">
                  <div className="control">
                    <div className="is-fullwidth mr-2">
                      <SmallSelect
                          value={selectcustomer}
                          onChange={handleCustomerChange}
                          options={options}
                          isLoading={isLoading}
                          isClearable={true} 
                          placeholder="Select Customer"
                        />
                    </div>
                  </div>
                </div>
                <div className="column is-1">
                  <div className="control">
                    <button type="submit" className="button is-small is-info">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      
        <div className="table-container">
            <table className="table is-striped is-narrow is-hoverable is-fullwidth is-size-7">
              <thead>
                <tr>
                  <th>No</th>
                  <th className="has-text-centered">Actions</th>
                  <th>Contract_No</th>
                  <th>Customer</th>       
                  <th>Contract_Value</th>            
                  <th>Paid_Status</th>
                  <th>Last_Paid_Amount</th>
                  <th>Due_Amount</th>               
                  <th>End_Guarantee</th>
                  <th>Status_Guarantee</th>
                  <th>End_Contract</th>
                  <th>Contract_Remaining</th>      
                </tr>
              </thead>
              <tbody>
              {contracts.map((contract, index) => (
                <tr key={contract.uuid}>                    
                    <td>{index + 1}</td>
                    <td className="has-text-centered">                      
                      <Dropdown trigger={<a className="button is-small is-link">Click Action</a>}>
                        <Link to={`/contracts/payment/${contract.uuid}`} className="dropdown-item"><IoCashOutline />&nbsp;Add Payment</Link> 
                        <Link to={`/contracts/detail-payment/${contract.uuid}`} className="dropdown-item"><IoCashSharp />&nbsp;Detail Payment</Link>
                        <Link to={`/contracts/detail/${contract.uuid}`} className="dropdown-item"><IoListOutline />&nbsp;Detail Contract</Link>
                        
                        <hr className="dropdown-divider" />
                        <a href="#" onClick={() => deleteContract(contract.uuid)} className="dropdown-item has-text-danger"><IoCloseCircleOutline />&nbsp;Delete</a>                     
                      </Dropdown>                        
                    </td>
                    <td className="has-text-centered">{contract.contract_no}</td>
                    <td>{contract.client.name}</td>  
                    <td className="has-text-right">
                        <NumericFormat
                        value={contract.contract_value}
                        displayType="text"
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true} />
                    </td>
                    <td className="has-text-centered">
                      {(contract.paid_status==="Paid") ? <span className="tag is-success">Paid</span>
                      : (contract.paid_status==="Partial") ? <span className="tag is-warning">Partial</span>
                      : <span className="tag is-danger">Unpaid</span> }
                      </td>
                    <td className="has-text-right">
                        <NumericFormat
                        value={contract.paid_amount}
                        displayType="text"
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true} />
                    </td>
                    <td className="has-text-right">
                        <NumericFormat
                        value={contract.due_amount}
                        displayType="text"
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true} />
                    </td>
                    <td className="has-text-centered">
                        {new Date(contract.end_guarantee).toLocaleDateString('id', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        })}                    
                    </td>
                    <td className="has-text-centered">
                      {calculateGuarantee(contract.end_guarantee)}
                    </td>
                    <td className="has-text-centered">
                        {new Date(contract.end_contract).toLocaleDateString('id', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        })}                    
                    </td>
                    <td className="has-text-centered has-text-weight-bold">
                      {calculateContract(contract.end_contract)}
                    </td>
                   
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="is-size-7">
          Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
        </p>
        <p className="has-text-centered has-text-danger">{msg}</p>
        <nav
          className="pagination is-centered is-size-7"
          key={rows}
          role="navigation"
          aria-label="pagination"
        >
          <ReactPaginate
            breakLabel="..."
            previousLabel={"< Prev"}
            nextLabel={"Next >"}
            pageCount={Math.min(10, pages)}
            onPageChange={changePage}
            containerClassName={"pagination-list"}
            pageLinkClassName={"pagination-link"}
            previousLinkClassName={"pagination-previous"}
            nextLinkClassName={"pagination-next"}
            activeLinkClassName={"pagination-link is-current"}
            disabledLinkClassName={"pagination-link is-disabled"} />
        </nav>
    </div>
  );
}

export default ContractList;
